import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio15',
  templateUrl: './portfolio15.component.html',
  styleUrls: ['./portfolio15.component.css'],
  standalone: false,
})
export class Portfolio15Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
